import { getUserAccounts } from '../../components/Header/dynamic/headerFunctions.js';
import { AuthenticatedUserRole } from '../../generated/api/models.js';
import type { Address } from '../../generated/api/models.js';
import type { AuthenticatedUser } from '../../public/site/authState';

export const formatAddress = (address?: Address): string | undefined => {
  if (address === undefined) {
    return undefined;
  }
  return (
    address.line1 + (address.line2 ? ' ' + address.line2 : '') + ', ' + address.postalCode + ', ' + address.postOffice
  );
};

export const getCompanyName = (authenticatedUser?: AuthenticatedUser, accountMasterId?: string) => {
  if (!accountMasterId) {
    return '';
  }
  const userAccounts = getUserAccounts(authenticatedUser);
  return userAccounts.find(account => account.accountMasterId === accountMasterId)?.name ?? '';
};

export const isMultiBiz = (authenticatedUser?: AuthenticatedUser): boolean =>
  !!(authenticatedUser && getUserAccounts(authenticatedUser).length > 1);

export const getPrimaryMdmId = (authenticatedUser?: AuthenticatedUser) =>
  authenticatedUser?.contact?.accountContactRelationships?.find(acr => acr.isPrimaryAccount)?.accountMasterId;

export const isAdminUser = (user?: AuthenticatedUser): boolean =>
  user?.userRole === AuthenticatedUserRole.ADMIN || user?.userRole === AuthenticatedUserRole.KEY_USER;
